import * as React from 'react';
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from 'react-icons/md';
import {
  DateTextBox,
  FlexLayout,
  GridLayout,
  SearchLayout,
  TextBox,
} from '../../../../components';
import {
  Global,
  TemplateProps,
} from '../../../../constants';
import { MonthProject } from './MonthProject';
import {
  Date6Calculator,
  Date8,
} from '../../../../utils/time';
import { Format } from '../../../../utils/string';

/**
 * 화면
 * @window  w_tb_monend_incentive_notuseamt
 * @category 월프로젝트이익금체크
 */
export const MonthProjectTemplate: React.FC<TemplateProps<MonthProject>> = ({
  scope,
  update,
}) => {
  const setData = update!;

  return (
    <FlexLayout isVertical={true}>
      <FlexLayout size={Global.LAYOUT_SEARCH_HEIGHT_1}>
        <SearchLayout>
          <FlexLayout size={200}>
            <span>월</span>
            <DateTextBox
              value={scope.state.yearmon}
              textAlign="center"
              format="####년 ##월"
              onChange={(value) => {
                setData({ yearmon: value },
                  () => scope.onRetrieveEvent());
              }}
              head={(<button
                onClick={() => {
                  setData({ yearmon: new Date6Calculator(scope.state.yearmon).add(-1).toString() },
                    () => scope.onRetrieveEvent());
                }}
              >
                <MdKeyboardArrowLeft size={24}/>
              </button>)}
              trail={(<button
                onClick={() => {
                  setData({ yearmon: new Date6Calculator(scope.state.yearmon).add().toString() },
                    () => scope.onRetrieveEvent());
                }}
              >
                <MdKeyboardArrowRight size={24}/>
              </button>)}
              isDisabledTrackingStateChange={true}
            elField="yearmon"
            />
          </FlexLayout>

          <FlexLayout size={400}>
            <span>검색어</span>
            <TextBox
              placeholderColor="#CACACA"
              placeholderAlign="left"
              placeholder="프로젝트로 검색하세요"
              value={scope.state.searchQuery}
              onChange={(value) => setData({ searchQuery: value })}
              onEnter={() => scope.onRetrieveEvent()}
              isDisabledTrackingStateChange={true}
            elField="searchQuery"
            />
          </FlexLayout>
        </SearchLayout>
      </FlexLayout>

      <GridLayout
        ref={scope.grid}
        header={[
          {
            id: 'rcvdate',
            text: '수금일자',
            width: 9,
            render: (x) => (
              <FlexLayout
                justify="center"
                align="center"
              >
                {Date8.withDash(x.rcvdate)}
              </FlexLayout>
            ),
          },
          {
            id: 'projno',
            text: '프로젝트No',
            width: 9,
          },
          {
            id: 'projnm',
            text: '현장명',
            width: 27,
            render: (x) => (
              <FlexLayout
                justify="left"
                align="center"
              >
                {x.projnm}
              </FlexLayout>
            ),
          },
          {
            id: 'comppernm',
            text: '주담당자',
            width: 8,
          },
          {
            id: 'pcode',
            text: '품목코드',
            width: 10,
            render: (x) => (
              <FlexLayout
                style={{ color: x.phm_mamt === '0' ? 'var(--color-red)' : '' }}
                justify="center"
                align="center"
              >
                {x.pcode}
              </FlexLayout>
            ),
          },
          {
            id: 'pname',
            text: '품목명',
            width: 15,
            render: (x) => (
              <FlexLayout
                style={{ color: x.phm_mamt === '0' ? 'var(--color-red)' : '' }}
                justify="left"
                align="center"
              >
                {x.pname}
              </FlexLayout>
            ),
          },
          {
            id: 'compamt',
            text: '공사금액',
            width: 10,
            render: (x) => (
              <FlexLayout
                style={{ color: x.phm_mamt === '0' ? 'var(--color-red)' : '' }}
                justify="right"
                align="center"
              >
                {Format.number(x.compamt)}
              </FlexLayout>
            ),
          },
          {
            id: 'phm_mamt',
            text: '매입단가',
            width: 12,
            render: (x) => (
              <FlexLayout
                style={{ color: x.phm_mamt === '0' ? 'var(--color-red)' : '' }}
                justify="right"
                align="center"
              >
                {Format.number(x.phm_mamt)}
              </FlexLayout>
            ),
          },
        ]}
        data={scope.state.data}
        infinityHandler={scope.infinity}
        rowHeight={Global.LAYOUT_GRID_HEIGHT_1}
        onRowClick={(item) => scope.onRowFocusEvent(item)}
      elGrid="data"
      />
    </FlexLayout>
  );
};
